import { api } from './client';

export interface FulfillmentRow {
  enqId: number;
  enqNo: string;
  /** 'Shopify' for online orders. */
  source?: string | null;
  /** Shopify order no. (e.g. "#20470") for online orders. */
  customerPoRef?: string | null;
  enqDate: string;
  partyName: string;
  stage: string;
  estOrderValue: number;
  hasMrn: boolean;
  hasPendingQty: boolean;
  creditStatus: string | null;
  doRef: string | null;
  doStage: string | null;
  pickStage: string | null;
  packStage: string | null;
  outwardGrnRef: string | null;
  invoiceRef: string | null;
  invoiceStatus: string | null;
  gatePassRef: string | null;
  deliveryStatus: string | null;
  deliveryDate: string | null;
}

export interface FulfillmentKpis {
  delivered: number;
  inTransit: number;
  partialPending: number;
  totalInvoicedValue: number;
}

export async function listFulfillment(filter: {
  stage?: string;
  partyId?: number;
  from?: string;
  to?: string;
} = {}): Promise<FulfillmentRow[]> {
  const r = await api.get<FulfillmentRow[]>('/fulfillment', { params: filter });
  return r.data;
}

export async function getFulfillmentKpis(): Promise<FulfillmentKpis> {
  const r = await api.get<FulfillmentKpis>('/fulfillment/kpis');
  return r.data;
}

export function fulfillmentExportPath(filter: {
  stage?: string;
  partyId?: number;
  from?: string;
  to?: string;
} = {}): string {
  const search = new URLSearchParams(
    Object.fromEntries(
      Object.entries(filter).filter(([, v]) => v != null && v !== ''),
    ) as Record<string, string>,
  ).toString();
  return `/fulfillment/export.xlsx${search ? `?${search}` : ''}`;
}
